import React from "react";
import Confetti from "react-confetti";
import useWindowDimensions from "../../hooks/useWindowDimensions";

function SuccessDisplay() {
  const { width, height } = useWindowDimensions();
  return (
    <section>
      <Confetti width={width} height={height} />
        <div className="description success-display-container">
          <h3 className="sub-success-h3">You are now subscribed!</h3>
        </div>
    </section>
  );
}

export default SuccessDisplay;
